import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import BaseIconButtonWithTooltip from '../BaseIconButtonWithTooltip';
/**
 * Vybere button k zobrazeni.
 *
 * Pokud dostane `icon` renderuje IconButton. V opacnem pripade vyrenderuje Button.
 *
 * @ignore
 */

function ButtonSelector(_ref) {
  var icon = _ref.icon,
      iconColor = _ref.iconColor,
      id = _ref.id,
      label = _ref.label,
      tooltipPlacement = _ref.tooltipPlacement,
      rest = _objectWithoutProperties(_ref, ["icon", "iconColor", "id", "label", "tooltipPlacement"]);

  var isIB = Boolean(icon);

  var buttonProps = _extends({}, rest, {
    'aria-owns': id,
    'aria-haspopup': 'true',
    'aria-label': label
  });

  return !isIB ? React.createElement(Button, buttonProps, label) : React.createElement(BaseIconButtonWithTooltip, _extends({}, buttonProps, {
    label: label,
    placement: tooltipPlacement,
    icon: icon,
    iconColor: iconColor
  }));
}

ButtonSelector.propTypes = {
  color: PropTypes.oneOf(['default', 'primary', 'secondary', 'inherit']),
  icon: PropTypes.element,
  iconColor: PropTypes.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),
  id: PropTypes.string,
  label: PropTypes.node,
  onClick: PropTypes.func.isRequired,

  /**
   * @placementPropType
   */
  tooltipPlacement: PropTypes.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top'])
};
ButtonSelector.defaultProps = {
  color: undefined,
  icon: null,
  iconColor: undefined,
  id: null,
  label: null,
  tooltipPlacement: undefined
};
export default ButtonSelector;